export class GenericValidator {
  key?: string;
  message?: string;
  value?: any;
  fieldLocalization?: any;
  /**
   *
   */
  constructor(options: { key?: string; message?: string; value?: any, fieldLocalization?: any }) {
    this.key = options.key;
    this.message = options.message;
    this.value = options.value;
    this.fieldLocalization = options.fieldLocalization;
  }
}
